<template>
  <div class="video-block">
    <div class="video-block__bg" />
    <div class="video-block__text video-block-text">
      <h1 class="video-block-text__title">Студия дизайна интерьера</h1>
      <p class="video-block-text__annotation">
        Предоставляем полный цикл услуг от проектирования до реализации ремонта
        жилых и коммерческих помещений
      </p>
      <div class="video-block-text__buttons">
        <AppButton @click="scrollToBlock('request-form')"
          >Рассчитать стоимость проекта</AppButton
        >
        <AppButton to="/projects" theme="white-transparent">
          Посмотреть наши работы
        </AppButton>
      </div>
    </div>
    <video
      style="
        display: flex;
        object-fit: cover;
        background-size: cover;
        width: 100%;
        height: 100vh;
      "
      preload="auto"
      loading="lazy"
      playsinline=""
      autoplay=""
      loop=""
      muted=""
    >
      <source src="~@/assets/images/main-page/bg-video.mp4" type="video/mp4" />
    </video>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import AppButton from '@/components/ui/AppButton/Index.vue'

import useScrollToBlock from '@/features/useScrollToBlock'

export default defineComponent({
  name: 'VideoBlock',
  components: { AppButton },
  setup() {
    return { ...useScrollToBlock() }
  },
})
</script>

<style lang="scss" scoped src="./Index.scss" />
